/**
 * All possible document statuses returned by Cortex in `ec__status`.
 * Kept as a runtime tuple (not just a type) so it can act as the source of truth
 * for exhaustiveness checks — e.g. asserting every status has a translated label.
 */
export const DOCUMENT_STATUSES = ['sent', 'complete', 'partial', 'cancelled', 'voided'];
